import { render, staticRenderFns } from "./ProveedoresMantenimiento.vue?vue&type=template&id=03e4b481&"
import script from "./ProveedoresMantenimiento.vue?vue&type=script&lang=js&"
export * from "./ProveedoresMantenimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports